<template>
  <div v-if="isOpen" class="menu">
    <ul class="nav">
      <MobileNavMenuItem
        v-for="navItem in navItems"
        :key="navItem.value"
        :label="navItem.name"
        :to="{ name: navItem.value }"
        :active="$route.name == navItem.value"
        @click="$emit('close')"
      />
    </ul>
    <div class="menu-actions">
      <div class="dark-mode action-item">
        <Light v-if="isDarkMode" :color="'rgb(255 255 255 / 60%)'" />
        <Dark v-else :color="'rgb(255 255 255 / 60%)'" />
      </div>
      <div
        class="action-item language-dropdown"
        :class="{ open: dropdownOpened }"
      >
        <Dropdown
          position="right-top"
          v-model="currentLanguage"
          v-model:open="dropdownOpened"
          :options="languageOptions"
        >
          <component v-if="selectedLanguageIcon" :is="selectedLanguageIcon" />
        </Dropdown>
      </div>
    </div>
    <div class="close" @click="$emit('close')">
      <Vector />
    </div>
  </div>
</template>
<script lang="ts">
import { Component, defineComponent, shallowRef } from "vue"
import MobileNavMenuItem from "./MobileNavMenuItem.vue"
import Dropdown, { DropdownOption } from "@/components/uikit/Dropdown.vue"
import {
  Dark,
  Light,
  English,
  German,
  Chinese,
  French,
  Spanish,
  Vector,
} from "@/components/icons/index"
import i18n from "@/translations"
import Russia from "../icons/languages/Russia.vue"
export default defineComponent({
  name: "MobileMenuModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MobileNavMenuItem,
    Dropdown,
    Dark,
    Light,
    Vector,
    English,
    German,
    Chinese,
    French,
    Spanish,
  },
  data() {
    return {
      isDarkMode: true,
      navItems: [
        { name: "layout.nav.home", value: "home" },
        {
          name: "layout.nav.inventory",
          value: "inventory",
        },
        {
          name: "layout.nav.game_history",
          value: "game-history",
        },
        {
          name: "layout.nav.referral_program",
          value: "referral-program",
        },
        {
          name: "layout.nav.leaderboard",
          value: "leaderboard",
        },
      ],
      dropdownOpened: false,
      languageOptions: [
        {
          label: "English",
          key: "en",
          icon: shallowRef(English),
        },
        {
          label: "Русский",
          key: "ru",
          icon: shallowRef(Russia),
        },
        // { label: "German", key: "ge", icon: shallowRef(German) },
        // { label: "Chinese", key: "ch", icon: shallowRef(Chinese) },
        // { label: "French", key: "fr", icon: shallowRef(French) },
        // { label: "Spanish", key: "sp", icon: shallowRef(Spanish) },
      ] as DropdownOption[],
      currentLanguage: "en",
    }
  },
  watch: {
    currentLanguage(newLanguage) {
      i18n.global.locale = newLanguage
    },
    isOpen(val) {
      if (val) {
        document.documentElement.style.overflow = "hidden" // <html>
        document.body.style.overflow = "hidden" // <body>
      } else {
        document.documentElement.style.overflow = ""
        document.body.style.overflow = ""
      }
    },
  },
  computed: {
    selectedLanguageIcon(): Component | undefined {
      return this.languageOptions.find(
        (option: DropdownOption) => option.key === this.currentLanguage
      )?.icon
    },
  },
  beforeUnmount() {
    document.documentElement.style.overflow = ""
    document.body.style.overflow = ""
  },
})
</script>
<style lang="scss" scoped>
.menu {
  position: fixed;
  z-index: 50;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(33, 36, 41, 0.88);
  backdrop-filter: blur(12px);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ul {
    /* Frame 2087325326 */

    /* Auto layout */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 48px;

    width: 167px;
    height: 256px;

    list-style: none;
    margin-bottom: 60px;
    padding: 1rem;
  }

  .menu-actions {
    gap: 24px;
    display: flex;
    position: absolute;
    bottom: 60px;

    .action-item {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      background: rgba(255, 255, 255, 0.04);
      border-radius: 12px;
      cursor: pointer;

      &.language-dropdown {
        &.open,
        &:hover {
          position: relative;
          &::after {
            pointer-events: none;
            content: "";
            position: absolute;
            inset: 0;
            border-radius: 12px;
            padding: 1px;
            background: var(--text-gradient);
            -webkit-mask: linear-gradient(#000 0 0) content-box,
              linear-gradient(#000 0 0);
            mask: linear-gradient(#000 0 0) content-box,
              linear-gradient(#000 0 0);
            -webkit-mask-composite: xor;
            mask-composite: exclude;
          }
        }
      }
    }
  }

  .close {
    position: absolute;
    cursor: pointer;
    width: 20px;
    height: 20px;
    right: 24px;
    top: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
